import { redirect } from '@tanstack/react-router'

import type { RouteGuardDecision } from '@/features/auth/guards'
import { sessionQueryOptions } from '@/features/auth/session'
import { tenantsQueryOptions } from '@/features/tenants/queries'
import { queryClient } from '@/lib/queryClient'

/** Efeito de router (throw redirect) a partir de uma decisao pura de features/auth/guards.ts. */
export function applyGuardDecision(decision: RouteGuardDecision): void {
  if (decision.kind === 'allow') {
    return
  }

  // O redirect do TanStack Router e um Response (nao um Error) por desenho da biblioteca:
  // e assim que o router reconhece e trata a navegacao no beforeLoad.
  if (decision.to === '/app/$tenantSlug/dashboard') {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() retorna Response, padrao do TanStack Router
    throw redirect({ to: decision.to, params: decision.params })
  }

  // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() retorna Response, padrao do TanStack Router
  throw redirect({ to: decision.to })
}

/** Sessao atual, via cache do TanStack Query (mesma fonte usada por useSession). */
export async function loadSession() {
  return queryClient.ensureQueryData(sessionQueryOptions)
}

/** Tenants do usuario autenticado, via cache do TanStack Query (mesma fonte usada por useTenants). */
export async function loadTenants() {
  return queryClient.ensureQueryData(tenantsQueryOptions)
}
